/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_SyncedInputs */

const cs_col_synced = /** @type {(inputs: Col_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední synchronizace`)
};

const en_col_synced = /** @type {(inputs: Col_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Sync`)
};

/**
* | output |
* | --- |
* | "Last Sync" |
*
* @param {Col_SyncedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_synced = /** @type {((inputs?: Col_SyncedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_SyncedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_synced(inputs)
	return cs_col_synced(inputs)
});